
import React, { Component } from 'react';
import { withRouter, Redirect } from 'react-router-dom'
import { Field, reduxForm } from 'redux-form';
import { InputWithErrors } from '../../lib/forms';
import { isRequired } from '../../lib/forms/Validations';

import { connect } from 'react-redux';

import AuthService from '../../services/AuthService';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import ForgotPasswordURL from '../../localeAssets/ForgotPasswordURL';

let LoginFormView = ({ error, handleSubmit, translate, currentLanguage, }) => {
  if (error === "authValidation") {
    error = translate("authValidation-message");
  }
  return (
    <div id="login">
      <div className="container text-center">
        <div className="row justify-content-center">
          <div className="col-12 col-md-8 col-lg-4">
            <div className="card">
              <div className="card-block">
                <form className="form" action="" method="post" onSubmit={handleSubmit}>
                  {error && <p className="text-danger" role="alert">{error}</p>}
                  <div className="form-group" ah-form-group="ah-form-group">
                    <div className="input-group">
                      <div className="input-group-addon">
                        <i className="material-icons">person</i>
                      </div>
                      <Field name="login" label="Login" placeholder={translate('login')} translate={translate} className="form-control" component={InputWithErrors} type="text" validate={[isRequired]} />
                    </div>
                    <div className="form-group-indicator" />
                  </div>
                  <div className="form-group" ah-form-group="ah-form-group">
                    <div className="input-group">
                      <div className="input-group-addon">
                        <i className="material-icons">lock</i>
                      </div>
                      <Field name="password" label="Password" placeholder={translate('password')} translate={translate} className="form-control password" component={InputWithErrors} type="password" validate={[isRequired]} />
                    </div>
                    <div className="form-group-indicator" />
                    <a className="btn btn-link btn-pwd" href={ForgotPasswordURL(currentLanguage)}>{translate('forgot-password')}</a>
                  </div>
                  <div className="row">
                    <div className="col">
                      <label className="custom-control custom-checkbox checkbox-save">
                        <Field name="rememberMe" component="input" type="checkbox" className="custom-control-input" />
                        <span className="custom-control-indicator" />
                        <span className="custom-control-description">{translate('remember-me')}</span>
                      </label>
                    </div>
                  </div>
                  <div className="row justify-content-center">
                    <div className="col-8"><input type="submit" className="btn btn-block btn-lg btn-login" value={translate('login-button')} /></div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
const viewMapStateToProps = state => ({
  translate: getTranslate(state.locale),
  currentLanguage: getActiveLanguage(state.locale).code,
});

const viewMapDispatchToProps = dispatch => ({});

LoginFormView = connect(
  viewMapStateToProps,
  viewMapDispatchToProps,
)(LoginFormView);
LoginFormView = reduxForm({
  form: 'Login',
})(LoginFormView)

class LoginFormHandler extends Component {
  state = { redirectToReferrer: false };
  handleSubmit(values) {
    const { translate, history, setFlashMessage, currentLanguage, setFlashMessageNull, location, dispatch } = this.props;
    return AuthService.login(values)
      .then(res => {
        AuthService.setAuthUserProfile(dispatch);
        this.setState({ redirectToReferrer: true });
        setFlashMessageNull()
      })
      .catch(error => {
        setFlashMessage(`${translate('login-or-password-incorrect')}`, false);
      })
  }
  render() {
    let { from } = this.props.location.state || { from: { pathname: "/" } };
    let { redirectToReferrer } = this.state;

    if (redirectToReferrer) return <Redirect to={from} />;
    return (
      <div>
        <LoginFormView onSubmit={this.handleSubmit.bind(this)} />
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    setFlashMessage: (message, success) => {
      dispatch(
        {
          type: 'SET_FLASH_MESSAGE',
          message: message,
          success: success
        }
      );
    },
    setFlashMessageNull: () => {
      dispatch(
        {
          type: 'SET_FLASH_MESSAGE_NULL',
        }
      );
    },
  }
}

LoginFormHandler = connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginFormHandler);

LoginFormHandler = withRouter(LoginFormHandler);
export default LoginFormHandler;



// WEBPACK FOOTER //
// ./src/components/Login/Login.js